class OntarioObstetricalPatientPartnerInformation {
    public FirstName: string;
    public LastName: string;
    public Occupation: string;
    public EducationLevel: string;
    public Age: number | null;

    constructor(fields?: Partial<OntarioObstetricalPatientPartnerInformation>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalPatientPartnerInformation };
